export default __webpack_public_path__ + "static/media/error-icon.ef9f21a2.svg";